<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="modalClose()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">

  @if (isLoading) {
<mat-progress-bar
                    color="primary"
                    mode="indeterminate">
  </mat-progress-bar>
}

  @if (!isLoading && firstRow.length > 0) {
<div class="summary-section">
    <table class="table table-bordered custom-table" style="width:100%; font-size:12px;">
      <thead>
        <tr>
          <th>LEID</th>
          <th>Tax Code</th>
          <th>Reporting Period</th>
          <th>Entity Name</th>
          <th>Tax Type</th>
          <th>ME Code</th>
          <th>Currency</th>
          <th>HO LEID</th>
          <th>HO Tax Code</th>
          <th>HO Reporting Period</th>
          <th>HO Entity Name</th>
          <th>HO Tax Type</th>
          <th>Tax Year Begin</th>
          <th>Tax Year End</th>
          <th>Source System Flag</th>
        </tr>
      </thead>
      <tbody>
        @for (item of firstRow; track $index) {
<tr>
          <td>{{ item.LEID }}</td>
          <td>{{ item.CDR_NO }}</td>
          <td>{{ item.REPORTING_PERIOD }}</td>
          <td>{{ item.LE_NAME }}</td>
          <td>{{ item.LE_TAX_TYPE }}</td>
          <td>{{ item.ME_CODE }}</td>
          <td>{{ item.CURR }}</td>
          <td>{{ item.HO_LEID }}</td>
          <td>{{ item.HO_CDR_NO }}</td>
          <td>{{ item.HO_REPORTING_PERIOD }}</td>
          <td>{{ item.HO_LE_NAME }}</td>
          <td>{{ item.HO_TAX_TYPE }}</td>
          <td>{{ item.TAX_YEAR_BEGIN }}</td>
          <td>{{ item.TAX_YEAR_END }}</td>
          <td>{{ item.SOURCE_SYSTEM_FLAG }}</td>
        </tr>
}
      </tbody>
    </table>
  </div>
}

  @if (!isLoading && splAllocPopupData && splAllocPopupData.length > 0) {
<div class="details-section">
    <div class="table-scroll">
      <table class="table table-bordered table-striped custom-table" style="font-size:12px;">
        <thead>
          <tr>
            @for (header of headers; track $index) {
<th [id]="header.key">
              <span [ngStyle]="{
                'width': header.key === 'ACCT' ? '100px' :
                         header.key === 'ACCT_DESC' ? '350px' :
                         header.key === 'TRADING_PARTNER' ? '150px' :
                         header.key === 'ISSUE_KEY' ? '50px' :
                         header.key === 'PSHIP_AMT' || header.key === 'PSHIP_AMT_USD' || header.key === 'TOTAL_ALLOCATION' ? '210px' :
                         header.key === 'VARIANCE' ? '180px' :
                         header.key === 'OVERRIDE_TYPE' ? '150px' : 'auto',
                'display': 'inline-block',
                'text-align': (header.key === 'PSHIP_AMT' || header.key === 'PSHIP_AMT_USD' || header.key === 'TOTAL_ALLOCATION' || header.key === 'VARIANCE') ? 'right' : 'left'
              }">
                <b>{{header.value}}</b>
              </span>
            </th>
}
            @for (ptrHeader of ptrHeaders; track $index; let prop_key = $index) {
<th style="padding: 0px !important;" [id]="ptrHeader.key">
              @if (ptrHeader.key.includes('/')) {
<span style="width:570px!important;">
                <table class="partnerCell">
                  <thead>
                    <tr>
                      <th style="border:0px !important; text-align: center" colspan="3"><b>{{ptrHeader.value}}</b></th>
                    </tr>
                    <tr>
                      <th style="width:210px!important; text-align: center !important; border:0px !important;">Default Allocation</th>
                      <th style="width:180px!important; text-align: center !important; border:0px !important;">% Override</th>
                      <th style="width:180px!important; text-align: center !important; border:0px !important;">Amount Override</th>
                    </tr>
                    <tr>
                      <th style="width:210px!important; border:0px !important; text-align: right !important;">&nbsp;</th>
                      <th style="width:180px!important; text-align: center; border:0px !important;">({{ptrRatioArray[prop_key]}})</th>
                      <th style="width:180px!important; border:0px !important">&nbsp;</th>
                    </tr>
                  </thead>
                </table>
              </span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (item of splAllocPopupData; track $index; let i = $index) {
<tr>
            @for (header of headers; track $index) {
<td>
              @if (header.key === 'ACCT') {
<span>{{item[header.key]}}</span>
}
              @if (header.key === 'ACCT_DESC') {
<span>{{item[header.key]}}</span>
}
              @if (header.key === 'TRADING_PARTNER') {
<span>{{(item[header.key] === '0' ? '': item[header.key])}}</span>
}
              @if (header.key === 'ISSUE_KEY') {
<span style="width:50px!important;">{{item[header.key]}}</span>
}
              @if (header.key === 'PSHIP_AMT') {
<span style="width:210px!important;text-align: right !important; display:inline-block;">{{item[header.key] | number}}</span>
}
              @if (header.key === 'PSHIP_AMT_USD') {
<span style="width:210px!important;text-align: right !important; display:inline-block;">{{item[header.key] | number}}</span>
}
              @if (header.key === 'TOTAL_ALLOCATION') {
<span style="width:210px!important;text-align: right !important; display:inline-block;">{{item[header.key] | number}}</span>
}
              @if (header.key === 'VARIANCE') {
<span style="width:180px!important;text-align: right !important; display:inline-block;" [style.color]="item[header.key] !== 0 ? 'red' : null"><b>{{item[header.key]}}</b></span>
}
              @if (header.key === 'OVERRIDE_TYPE') {
<span style="width:150px!important;text-align: center !important;">
                <label style="margin-right:10px; cursor:pointer;">
                  <input type="radio" [name]="'radio-group-'+i" [checked]="item[header.key] === 0" (change)="setOverrideOption('ratio', i)"> %
                </label>
                <label style="cursor:pointer;">
                  <input type="radio" [name]="'radio-group-'+i" [checked]="item[header.key] === 1" (change)="setOverrideOption('amount', i)"> Amount
                </label>
              </span>
}
            </td>
}
            @for (ptrHeader of ptrHeaders; track $index) {
<td style="padding: 0px !important;">
              @if (ptrHeader.key.includes('/')) {
<span style="width:570px!important;">
                <table class="partnerCell">
                  <tbody>
                    <tr>
                      <td style="width:210px!important; text-align: right !important; border:0px !important;">
                        <span>{{item[ptrHeader.key].split(',')[0] | number}}</span>
                      </td>
                      <td style="width:180px!important; border:0px !important; padding-top: 0px !important;">
                        <input type="text" class="form-control input-sm"
                               style="text-align: right; width:150px;"
                               [id]="'ratio-override-'+i+'-'+ptrHeader.key"
                               #ratioOverrides
                               [ngModel]="item[ptrHeader.key].split(',')[2]"
                               (ngModelChange)="calcVariance({value: $event}, i, ptrHeader.key,'ratio')"
                               (keypress)="keyPressDecimal($event)"
                               [disabled]="item['OVERRIDE_TYPE'] === 1" />
                      </td>
                      <td style="width:180px!important; border:0px !important; padding-top: 0px !important;">
                        <input type="text" class="form-control input-sm"
                               style="text-align: right; width:150px;"
                               [id]="'amount-override-'+i+'-'+ptrHeader.key"
                               #amountOverrides
                               [ngModel]="item[ptrHeader.key].split(',')[1]"
                               (ngModelChange)="calcVariance({value: $event}, i, ptrHeader.key,'amount')"
                               (keypress)="keyPressNumbers($event)"
                               [disabled]="item['OVERRIDE_TYPE'] !== 1" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </span>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
}

  @if (!isLoading && (!splAllocPopupData || splAllocPopupData.length === 0)) {
<div style="padding: 15px; font-size: 12px;">
    No records found.
  </div>
}

</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" [disabled]="isSaving" (click)="saveSplAllocData()">
    @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="modalClose()">Cancel</button>
</div>
